module.exports = __webpack_public_path__ + "img/progressico2.562609d5.png";